import { Injectable } from '@angular/core'
import { NgbModalConfig } from '@ng-bootstrap/ng-bootstrap'

@Injectable()
export class ModalConfig extends NgbModalConfig {
    backdropClass = 'custom-modal-backdrop'
    windowClass = 'custom-modal'
    centered = true
}
